import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextDrugClopidogrel } from "./TextDrugClopidogrel";


export default function Clopidogrel() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
     <ButtonsText onClick={handleOpen} name='Clopidogrel' size='large' color='common.white' />
  
    <CustomDialog open={open} onClose={handleClose}

        title="Clopidogrel - PGx Recommendation"
        content={ <TextDrugClopidogrel />}

        />

</>
)}